import { render, staticRenderFns } from "./DetailsSoftwareSection.vue?vue&type=template&id=0c0e7f85&"
import script from "./DetailsSoftwareSection.vue?vue&type=script&lang=js&"
export * from "./DetailsSoftwareSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports